import {
  UPDATE_LOGGED_IN_USER,
  REGISTER,
  EMAIL,
  GET_USER_DATA,
  UPDATE_OTP_LOGIN,
  VIEW_DEMOGRAPHY,
} from '../types'

const INITIAL_STATE = {
  user: null,
  userRegister: [],
  emailData: [],
  userDetails: null,
  ProfileText: null,
  otpDetails: [],
  viewDemography: {
    isShow: null,
    permission: false,
    isDisable: false,
    isNormal:false,
    report: {
      reporterTitle: false,
      salutation: false,
      firstName: false,
      middleName: false,
      lastName: false,
      suffix: false,
      reporterStreet: false,
      postCode: false,
      city: false,
      state: false,
      addressOne: false,
      emailAddress: false,
      phoneNumber: false,
      faxNumber: false,
      alternatePhoneNumber:false,
      reportersOrganization: false,
      reporterDepartment: false,
    },
    patient: {
      salutation: false,
      firstName: false,
      middleName: false,
      lastName: false,
      ageGroup: false,
      country: false,
      pregnancyStatus: false,
      dateofBirth: false,
      gender: false,
      patientAge: false,
      unit: false,
    },
    patientChar: {
      initial: false,
      patientInitialOther: false,
      gpMedicalRecNo: false,
      specialistRecNo: false,
      hospitalRecordNo: false,
      investigationNo: false,
      patientHeight: false,
      patientWeight: false,
      bodyArea: false,
      imc: false,
      ethinicity: false,
      race: false,
    },
    parent: {
      salutation: false,
      firstName: false,
      middleName: false,
      lastName: false,
      parentIdentification: false,
      parentGender: false,
      dateofBirth: false,
      lastMenstrualPeriodDate: false,
      parentAgeTimeOnset: false,
      parentUnit: false,
      height: false,
      weight: false,
      country: false,
    },
  },
}
// var jwtDecode = require('jwt-decode')

const authReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_LOGGED_IN_USER:
      return {
        ...state,
        user: payload,
        ProfileText: payload?.fName
          ? (payload.fName[0]?.match(/^[a-zA-Z]$/)
              ? payload.fName[0].toUpperCase()
              : '') +
            (payload.lName?.[0]?.match(/^[a-zA-Z]$/)
              ? payload.lName[0].toUpperCase()
              : '')
          : '',
      }
    case REGISTER:
      return {
        ...state,
        userRegister: payload,
      }
    case EMAIL:
      return {
        ...state,
        emailData: payload.data,
      }

    case GET_USER_DATA:
      return {
        ...state,
        userDetails: payload.data,
      }

    case UPDATE_OTP_LOGIN:
      return {
        ...state,
        otpDetails: payload.data,
      }
    case VIEW_DEMOGRAPHY: {
      const { section, field } = payload || {}
      const current = state.viewDemography
 if (payload?.reset) {
    return {
      ...state,
      viewDemography: INITIAL_STATE.viewDemography,
    };
  }
      // Case 1: Toggle all
      if (!section && !field) {
        const toggleValue = !current.permission
        const toggleSection = (sectionData) =>
          Object.fromEntries(
            Object.keys(sectionData).map((key) => [key, toggleValue]),
          )

        return {
          ...state,
          viewDemography: {
            ...current,
            isShow:false,
            isNormal:false,
            permission: toggleValue,
            report: toggleSection(current.report),
            patient: toggleSection(current.patient),
            patientChar: toggleSection(current.patientChar),
            parent: toggleSection(current.parent),
          },
        }
      }

      // Case 2: Toggle single field in a section
      return {
        ...state,
        viewDemography: {
          ...current,
          [section]: {
            ...current[section],
            [field]: !current?.[section]?.[field] ?? false,
          },
        },
      }
    }

    default:
      return state
  }
}

export default authReducer
